import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ImageService } from 'src/app/shared/services/images/image.service';

@Component({
  selector: 'app-product-spotlight',
  standalone: false,
  templateUrl: './product-spotlight.component.html',
  styleUrl: './product-spotlight.component.scss'
})
export class ProductSpotlightComponent implements OnInit, OnChanges {
  
  @Input() title = '';
  @Input() textContent = '';
  @Input() imageFilePath = '';
  
  title_translated = '';
  textContent_translated = '';

  constructor(
    private translate: TranslateService,
    private imageSvc: ImageService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['title'] && changes['title'].currentValue) {
      this.title_translated = this.translate.instant(changes['title'].currentValue);
    }
    if (changes['textContent'] && changes['textContent'].currentValue) {
      this.textContent_translated = this.translate.instant(changes['textContent'].currentValue);
    }
  }

  ngOnInit(): void {
    this.title_translated = this.translate.instant(this.title);
    this.textContent_translated = this.translate.instant(this.textContent);
  }

  getImageFilePath(): SafeStyle {
    const imagePath = this.imageSvc.ImageLoc(this.imageFilePath);
    return this.sanitizer.bypassSecurityTrustStyle(`url(${imagePath})`);
  }
}
